import { TextField } from '@blueprinthq/joy'
import { Box, Flex, Text, VStack } from '@chakra-ui/react'
import { BPDateTimePicker } from '@components'
import { MergeIcon } from '@components/icons'
import type { FieldInputProps } from 'formik'
import { Field } from 'formik'
import React from 'react'

export const AddClientWorkflowDetails = () => {
  return (
    <Box
      width="100%"
      p={4}
      bg="gray.50"
      borderRadius="md"
      border="1px solid #2828280D"
    >
      <Flex alignItems="center" gap={2}>
        <MergeIcon />
        <Text color="#1B2B79" as="b">
          Add workflow details
        </Text>
      </Flex>
      <Text color="#1B2B79" fontSize="xs">
        Your clinic automates client activities - Add these details now to
        ensure workflows operate smoothly.
      </Text>
      <VStack spacing={4} width="100%" mt="small">
        <Field name="email">
          {({ field }: { field: FieldInputProps<string> }) => (
            <TextField
              {...field}
              label="Email Address"
              isRequired
              width="100%"
              bg="white"
            />
          )}
        </Field>
        <Field name="phoneNumber">
          {({ field }: { field: FieldInputProps<string> }) => (
            <TextField
              {...field}
              label="Cell phone (optional)"
              width="100%"
              bg="white"
            />
          )}
        </Field>
      </VStack>
    </Box>
  )
}
